import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import analyticsService from '../services/analyticsService';
import firstPartyAnalytics from '../services/firstPartyAnalytics';
import { useAuth } from '../contexts/AuthContext';

/**
 * SPA-Pageview-Tracking: meldet jeden Routenwechsel als page_view an GA4
 * UND (consent-unabhängig, cookieless) ans eigene Backend.
 * Muss INNERHALB des Routers UND des AuthProviders gemountet sein.
 * Rendert nichts.
 *
 * Beim ersten Mount wird init() versucht — hat der Nutzer früher schon
 * eingewilligt, startet GA damit auch ohne erneute Banner-Interaktion.
 * Alle Consent-/ID-Guards sitzen im analyticsService; das First-Party-
 * Tracking braucht keinen Consent (keine persistente Client-ID).
 */
const AnalyticsTracker: React.FC = () => {
  const location = useLocation();
  const { user } = useAuth();

  // User-ID als Ref: Login/Logout soll KEINEN zusätzlichen page_view
  // auslösen — nur echte Routenwechsel tracken.
  const userIdRef = useRef<string | null>(null);
  userIdRef.current = user?.id ?? null;

  useEffect(() => {
    analyticsService.init();
  }, []);

  useEffect(() => {
    // Titel setzt react-helmet asynchron — kurz warten, damit der
    // page_view den richtigen Seitentitel trägt.
    const timer = window.setTimeout(() => {
      const path = location.pathname + location.search;
      analyticsService.trackPageView(path);
      firstPartyAnalytics.trackPageView(path, document.title, userIdRef.current);
    }, 300);
    return () => window.clearTimeout(timer);
  }, [location.pathname, location.search]);

  return null;
};

export default AnalyticsTracker;
